var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinkedinMobileShare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 23,
  height: 21,
  viewBox: "0 0 23 21",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M13 0v6.414h-2.78c-2.738 0-5.923 1.4-7.945 3.866C.725 12.171 0 15.536 0 20.414h2c0-1.619 1.646-4.196 3.13-5.162l.164-.099c.844-.48 2.146-.739 3.901-.739H13v6.414l9-9A2 2 0 0 0 22 9zm2 4.83 5.585 5.584L15 15.998v-3.584H9.195c-2.225 0-3.942.373-5.155 1.162l-.201.137a8 8 0 0 0-1.108.97l-.294.32.03-.152c.309-1.479.764-2.582 1.355-3.303 1.628-1.986 4.24-3.134 6.398-3.134H15z"
})));
export default SvgLinkedinMobileShare;